var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/index.ts
import { setInitialUiConfig, useUiConfig as useUiConfig2 } from "@leagueplatform/ui-config";
import {
  AppEnvironment as AppEnvironment2,
  ENVIRONMENT,
  isDev,
  isNodeTestEnv as isNodeTestEnv3,
  isProduction,
  isStaging
} from "@leagueplatform/app-environment";
import {
  getModulePath,
  LEAGUE_MODULE_NAMES
} from "@leagueplatform/league-routes";
import {
  getCustomLocaleConfig,
  setCustomLocaleConfig
} from "@leagueplatform/locale-config";

// src/components/league-provider.tsx
import React4 from "react";
import { ObservabilityErrorBoundary } from "@leagueplatform/observability";
import { LeagueIntlProvider } from "@leagueplatform/locales";
import { ToastManager } from "@leagueplatform/toast-messages";
import { isNodeTestEnv as isNodeTestEnv2 } from "@leagueplatform/app-environment";
import { LeagueUIConfigProvider } from "@leagueplatform/ui-config";
import { SessionTimeout } from "@leagueplatform/session-timeout";
import { StandaloneAuth } from "@leagueplatform/auth-standalone";
import { Auth as Auth2, Implementation } from "@leagueplatform/auth";

// src/components/league-theme-provider.tsx
import React from "react";
import {
  formatThemeForCommons,
  GenesisThemeProvider
} from "@leagueplatform/genesis-commons";
import { UIKitThemeProvider } from "@leagueplatform/ui-kit";
import { GDSThemeProvider, loadTheme } from "@leagueplatform/genesis-core";
import { useUiConfig } from "@leagueplatform/ui-config";
var LeagueThemeProvider = ({ children }) => {
  const [uiConfig] = useUiConfig();
  const coreThemeOptions = __spreadValues({ useRems: false }, uiConfig == null ? void 0 : uiConfig.themeOptions);
  const coreTheme = loadTheme(uiConfig.theme, coreThemeOptions);
  const commonsTheme = formatThemeForCommons(uiConfig.theme);
  return /* @__PURE__ */ React.createElement(GDSThemeProvider, { theme: coreTheme }, /* @__PURE__ */ React.createElement(GenesisThemeProvider, { theme: commonsTheme }, /* @__PURE__ */ React.createElement(UIKitThemeProvider, null, children)));
};

// src/components/league-route-component-provider.tsx
import React2 from "react";
import { RouteComponentProvider, BaseRoute } from "@leagueplatform/routing";
import { RouteWithObservability } from "@leagueplatform/observability";

// src/utils/init-league.ts
import { initAnalytics } from "@leagueplatform/analytics";
import {
  SocketAsFetch as SocketAsFetch2,
  SocketAsFetchAnonymous
} from "@leagueplatform/socket-as-fetch";
import { leagueContentData } from "@leagueplatform/league-content-api";
import { leagueApi } from "@leagueplatform/league-fetch";
import { Auth } from "@leagueplatform/auth";
import { AppEnvironment } from "@leagueplatform/app-environment";
import { legacyRestApi } from "@leagueplatform/legacy-rest-api";
import { initObservability } from "@leagueplatform/observability";
import { overwriteRoutePaths } from "@leagueplatform/league-routes";
import { ReconnectingSocketController } from "@leagueplatform/league-socket";

// src/utils/collect-errors.ts
import { validate } from "superstruct";
function collectErrors(config2, schema) {
  const [err] = validate(config2, schema);
  if (!err) {
    return [];
  }
  return err.failures().map((failure) => {
    if (failure.type === "never") {
      return `The key '${failure.key}' is not part of League's initialization schema`;
    }
    return `${failure.key} is required when initializing League`;
  });
}

// src/utils/required-config-schema.ts
import { object, optional, string, func } from "superstruct";
var RequiredConfigSchema = object({
  tenantId: optional(string()),
  contentUrl: string(),
  analytics: optional(
    object({
      onIdentify: optional(func()),
      onTrackEvent: optional(func()),
      onTrackPageViewEvent: optional(func()),
      GAPropertyId: optional(string()),
      segmentKey: optional(string())
    })
  ),
  api: object({
    url: string(),
    wsUrl: string(),
    legacyRestApi: string()
  }),
  // TODO: make `auth` required once no app relies on not setting it (e.g., b2b and admin).
  auth: optional(object()),
  appEnvironment: string(),
  routes: optional(object()),
  ui: optional(object()),
  customMethods: object(),
  routing: optional(object()),
  mobileAppUrls: optional(
    object({
      appStoreUrl: optional(string()),
      playStoreUrl: optional(string())
    })
  )
});

// src/utils/tenant.ts
var validateTenant = (tenantId) => (
  // TODO: implement real validation
  // If TenantId does not exist show a message "please provide your TenantID"
  // If TenantId does not much with approved ID "TenantID does not much etc.."
  // If TenantId exists and is a much continue the rest of the auth process
  !!tenantId || true
);

// src/utils/validate-league-config.ts
function validateLeagueConfig(clientConfig) {
  if (!clientConfig)
    throw new Error(
      "Please provide a configuration object to initialize League"
    );
  const errors = collectErrors(clientConfig, RequiredConfigSchema);
  if (errors == null ? void 0 : errors.length) {
    throw new Error(`
${errors.join("\n")}`);
  }
  validateTenant(clientConfig.tenantId);
  return clientConfig;
}

// src/utils/api-requests.ts
import { leagueFetch } from "@leagueplatform/league-fetch";
import { SocketAsFetch } from "@leagueplatform/socket-as-fetch";
var win = window;
function wsSend(message_type, info) {
  return __async(this, null, function* () {
    var _a;
    try {
      const response = yield SocketAsFetch.fetch({ message_type, info });
      console.log(`\u{1F680} "${message_type}": success`);
      return response;
    } catch (error) {
      if (error instanceof Error) {
        const errorMessage = JSON.parse(error.message);
        console.error(
          `\u{1F494} "${message_type}": we had a problem with this api call: ${(_a = errorMessage == null ? void 0 : errorMessage.info) == null ? void 0 : _a.reason}`
        );
        console.error(error);
        return errorMessage;
      }
      throw error;
    }
  });
}
function RESTRequest(path, method = "GET", body) {
  return __async(this, null, function* () {
    let response;
    try {
      response = yield leagueFetch(path, {
        method,
        body
      });
    } catch (ex) {
      console.error(`window.league.api.rest ${method} failure`, ex);
      throw ex;
    }
    if (!response.ok) {
      console.error(
        `window.league.api.rest ${method} error response`,
        response.status,
        response.statusText
      );
    }
    return response;
  });
}
var LeagueConsoleAPI = {
  api: {
    ws: wsSend,
    send: wsSend,
    // legacy name for WS handler
    rest: RESTRequest
  }
};
function setupLeagueAPI() {
  if (!(win == null ? void 0 : win.league)) {
    win.league = LeagueConsoleAPI;
  }
}

// src/utils/construct-internal-auth-init-config.ts
var constructInternalAuthInitConfig = (authInitConfig, apiUrl) => {
  if ("clientOptions" in authInitConfig) {
    return authInitConfig;
  }
  return __spreadProps(__spreadValues({}, authInitConfig), {
    apiUrl
  });
};

// src/utils/init-league.ts
var config = null;
function init(clientConfig) {
  var _a;
  config = validateLeagueConfig(clientConfig);
  AppEnvironment.init(config.appEnvironment);
  initObservability({
    metadata: {
      moduleVersion: "0.14.0",
      tenantId: config.tenantId
    },
    tenantApiUrl: config.api.url,
    integrateWithLeagueRouting: (_a = clientConfig.routing) == null ? void 0 : _a.isUsingLeagueRouting
  });
  if (config.auth) {
    Auth.initialize(
      constructInternalAuthInitConfig(config.auth, config.api.url),
      config.contentUrl
    );
  }
  if (config.analytics) {
    initAnalytics(config.analytics, config.tenantId);
  }
  if (config.routes) {
    overwriteRoutePaths(config.routes);
  }
  SocketAsFetch2.init(config.api.wsUrl);
  SocketAsFetchAnonymous.init(config.api.wsUrl);
  ReconnectingSocketController.init(config.api.wsUrl);
  leagueContentData.init(config.contentUrl);
  leagueApi.init(config.api.url);
  legacyRestApi.init(config.api.legacyRestApi);
  setupLeagueAPI();
}
function getInitializationConfig() {
  if (!config)
    throw new Error("You must initialize League before using it.");
  return config;
}

// src/components/league-route-component-provider.tsx
var LeagueRouteComponentProvider = ({
  children
}) => {
  var _a;
  const routeComponent = ((_a = getInitializationConfig().routing) == null ? void 0 : _a.isUsingLeagueRouting) ? RouteWithObservability : BaseRoute;
  return /* @__PURE__ */ React2.createElement(RouteComponentProvider, { routeComponent }, children);
};

// src/components/react-query-provider-wrapper.tsx
import React3 from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { isNodeTestEnv } from "@leagueplatform/app-environment";
var ReactQueryProviderWrapper = ({
  children
}) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: isNodeTestEnv() ? false : 3
      }
    }
  });
  return /* @__PURE__ */ React3.createElement(QueryClientProvider, { client: queryClient }, children);
};

// src/components/league-provider.tsx
var LeagueProvider = ({ children }) => {
  const innerProviders = /* @__PURE__ */ React4.createElement(LeagueUIConfigProvider, null, /* @__PURE__ */ React4.createElement(ReactQueryProviderWrapper, null, /* @__PURE__ */ React4.createElement(LeagueThemeProvider, null, /* @__PURE__ */ React4.createElement(LeagueIntlProvider, null, /* @__PURE__ */ React4.createElement(LeagueRouteComponentProvider, null, children, !isNodeTestEnv2() && /* @__PURE__ */ React4.createElement(ToastManager, null), !isNodeTestEnv2() && Auth2.initialized && Auth2.implementation === Implementation.STANDALONE && /* @__PURE__ */ React4.createElement(
    SessionTimeout,
    {
      getIsAuthenticated: () => StandaloneAuth.client.isAuthenticated(),
      onSessionExpire: () => StandaloneAuth.client.logout(),
      onSessionExtend: () => StandaloneAuth.client.getTokenSilently({
        cacheMode: "off"
      })
    }
  ))))));
  return isNodeTestEnv2() ? innerProviders : /* @__PURE__ */ React4.createElement(ObservabilityErrorBoundary, null, innerProviders);
};

// src/hooks/use-league-init.hook.ts
import { useMemo } from "react";
var isInitialized = false;
function useLeagueInit(clientConfig) {
  useMemo(() => {
    if (!isInitialized) {
      init(clientConfig);
      isInitialized = true;
    }
  }, []);
}

// src/index.ts
var src_default = {
  init,
  getInitializationConfig,
  setInitialUiConfig,
  setCustomLocaleConfig,
  getCustomLocaleConfig,
  useUiConfig: useUiConfig2,
  LeagueProvider,
  getModulePath,
  LEAGUE_MODULE_NAMES,
  AppEnvironment: AppEnvironment2,
  isDev,
  isProduction,
  isStaging,
  isNodeTestEnv: isNodeTestEnv3,
  ENVIRONMENT,
  useLeagueInit
};
export {
  AppEnvironment2 as AppEnvironment,
  ENVIRONMENT,
  LEAGUE_MODULE_NAMES,
  LeagueProvider,
  src_default as default,
  getCustomLocaleConfig,
  getInitializationConfig,
  getModulePath,
  init,
  isDev,
  isNodeTestEnv3 as isNodeTestEnv,
  isProduction,
  isStaging,
  setCustomLocaleConfig,
  setInitialUiConfig,
  useLeagueInit,
  useUiConfig2 as useUiConfig
};
//# sourceMappingURL=index.js.map